import _ from 'lodash';
import React, { useState } from 'react';
import { FormState } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from 'src/app/redux/createAction';
import { Nav } from 'src/entities/Menu';
import { ObjectToArray } from 'src/helpers/dataHelpers';
import { actionsCompany } from 'src/pages/CompanyPage/_BLL/slice';
import { OwnCompanyTermsOfUse } from 'src/pages/CompanyPage/ui//OwnCompanyTermsOfUse/OwnCompanyTermsOfUse';
import { RequestStatus } from 'src/shared/api/types';
import { ButtonPrimary } from 'src/shared/ui/_buttons/ButtonPrimary';
import { Company, DashBoardMenuName, PropertiesCompany, PropertyType } from '../../_BLL/types';
import { useCompanyFormContext } from '../../lib/context/useCompanyPageContext';
import { FormGroupCompany } from '../FormGroupCompany/FormGroupCompany';
import { ProgressCalcCompany } from '../ProgressCalcCompany';
import { SubmitForRating } from '../SubmitForRating';
import s from './CompanyForm.module.scss';
import { FinalizingMessage } from '../FinalizingMessage/FinalizingMessage';

export const CompanyForm: React.FC = () => {
	// * Context
	const { currentCompany, companyMeta } = useCompanyFormContext();

	// * Selectors
	const activeMenuName = useAppSelector((state) => state.company.activeMenu);
	const finalizing = useAppSelector((state) => state.company.finalizing);
	const status = useAppSelector((state) => state.company.status);

	// * Actions
	const dispatch = useAppDispatch();
	const { updateCompany, setActiveMenuOption, setFormHaveErrors } = actionsCompany;

	// * Condition
	const isLoading = status === RequestStatus.loading;

	// * Menu
	const handleSetActiveMenuOption = (menuItem: DashBoardMenuName) => dispatch(setActiveMenuOption(menuItem));

	const onMenuClick = (menuItemName: DashBoardMenuName) => {
		if (activeMenuName !== DashBoardMenuName.welcome && submitValues) {
			dispatch(
				updateCompany({
					payload: submitValues,
					submitForRating: menuItemName === DashBoardMenuName.submitForRating,
				}),
			)
				.unwrap()
				.then(() => {
					menuItemName && handleSetActiveMenuOption(menuItemName);
				})
				.catch((error) => console.log('error :>> ', error));
		}
	};

	const getFormState = (
		formState: FormState<{
			properties: PropertiesCompany;
			id: number;
			entityName: 'company';
			displayName: string;
		}>,
	) => {
		if (_.isEmpty(formState.errors)) {
			dispatch(setFormHaveErrors(false));
		} else {
			dispatch(setFormHaveErrors(true));
		}
	};

	const [submitValues, setSubmitValues] = useState<Company | null>(null);

	const getSubmitForm = (values: Company) => {
		setSubmitValues(values);
	};

	// * Render
	return (
		<div>
			{companyMeta.tabs.map((tab) => (
				<ProgressCalcCompany
					key={tab.name}
					formValues={ObjectToArray({ ...currentCompany.properties, ...submitValues?.properties }) as { name: string; data: PropertyType }[]}
					tabMeta={tab}
				/>
			))}

			<div className={s.inner}>
				<Nav onMenuClick={onMenuClick} />

				{activeMenuName === DashBoardMenuName.welcome && (
					<div className={s.welcome}>
						<div
							className={s.content}
							data-test={'terms_of_use'}
						>
							<OwnCompanyTermsOfUse />
						</div>

						<div className={s.buttonsWrapper}>
							<ButtonPrimary
								data-test={'agree_or_next_button'}
								onClick={() => handleSetActiveMenuOption(DashBoardMenuName.general)}
								loading={isLoading}
							>
								Agree and continue
							</ButtonPrimary>
						</div>
					</div>
				)}

				{activeMenuName === DashBoardMenuName.submitForRating && (
					<div className={s.welcome}>
						<div className={s.content}>
							<SubmitForRating />
						</div>

						{finalizing && (
							<div className={s.buttonsWrapper}>
								<FinalizingMessage />
							</div>
						)}
					</div>
				)}

				{companyMeta.tabs.map((metaTab) => (
					<React.Fragment key={metaTab.name}>
						{activeMenuName === metaTab.name && (
							<FormGroupCompany
								companyActiveMenuMeta={metaTab}
								getFormState={getFormState}
								getFormValues={getSubmitForm}
							/>
						)}
					</React.Fragment>
				))}
			</div>
		</div>
	);
};
